import Container from '@/components/Atoms/Container'
import { Header } from '@/components/ui/header'
import { Outlet } from 'react-router'

export function TruckStopLayout() {
  return (
    <div className="mt-4 flex flex-col gap-4">
      <Header variant="h1" className="text-center">
        Motor Carrier and Automated Motor Vehicle Operator Lookup
      </Header>

      <Container className="mx-auto max-w-full px-4 lg:w-5xl">
        <div className="flex flex-1 flex-col gap-8 self-center">
          <Outlet />
        </div>
      </Container>
    </div>
  )
}
